import { render, staticRenderFns } from "./housemaid-excess-form.vue?vue&type=template&id=27b21a2e&scoped=true&"
import script from "./housemaid-excess-form.vue?vue&type=script&lang=js&"
export * from "./housemaid-excess-form.vue?vue&type=script&lang=js&"
import style0 from "./housemaid-excess-form.vue?vue&type=style&index=0&id=27b21a2e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b21a2e",
  null
  
)

export default component.exports